import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Buttons, Col, ContainerWithPadding, FormFieldHidable, Grid, nameof, NumberFormField, PInTableList, Popup, Row, SectionTitle, SelectFormFieldController, SelectOptionModel, TextFormField, TimePickerFormFieldController, ToggleFieldController } from 'traveldesk-ui'
import { actionCreators as timeSlotsActions } from '../../store/TimeSlots'
import DaysOfferedService from '../../services/daysOfferedService'
import { RouteComponentProps } from 'react-router'
import { ApplicationState } from '../../store'
import TimeSlot, { getTimeSlotTimeTypeOptions, getTimeSlotTypeOptions, TimeSlotTimeType, TimeSlotType } from '../../models/TimeSlot'
import { Controller, useForm } from 'react-hook-form'
import ExternalProviderOption, { ExternalProviderCodeType, ExternalProviderCodeTypesNames } from './ExternalProviderOption'
import { actionCreators as pickUpTimesActions } from '../../store/PickUpTimes'
import TimeSlotGroup from '../../models/TimeSlotGroup'
import parseId from '../../services/parseId'
import { Link } from 'react-router-dom'

interface Props extends RouteComponentProps<{ groupid: string, id: string }> {
}
const TimeSlotForm = (props: Props) => {
    const dispatch = useDispatch()
    const Localization = useSelector((state: ApplicationState) => state.localization.locale)
    const externalProvidersOptions = useSelector((state: ApplicationState) => state.timeSlots.externalProvidersOptions)
    const externalOffersMap = useSelector((state: ApplicationState) => state.timeSlots.externalOffersOptions)
    const pickUpTimesOptions = useSelector((state: ApplicationState) => state.pickUpTimes.options)
    const externalTimeSlotsMap = useSelector((state: ApplicationState) => state.timeSlots.externalTimeSlotsOptions)
    const [ts, setTs] = React.useState(TimeSlot.Create(new TimeSlot(), new TimeSlotGroup()))
    const timeSlotGroup = useSelector((state: ApplicationState) => state.timeSlots.timeSlotGroup)
    const daysOfferedOptions = React.useMemo(() => {
        const res = DaysOfferedService.getDaysNamesOptions(Localization)
        return res
    }, [Localization])
    React.useEffect(() => {
        if (pickUpTimesOptions.length == 0) {
            dispatch(pickUpTimesActions.requestPickUpTimesOptions())
        }
    }, [])
    React.useEffect(() => {
        const groupId = parseId(props.match.params.groupid)
        if (typeof groupId == undefined) {
            props.history.push('/timeslots')
        }
        dispatch(timeSlotsActions.manageTimeSlotGroup(groupId || 0))

    }, [props.match.params.id, props.match.params.groupid])
    React.useEffect(() => {
        if (!timeSlotGroup) return
        if (props.match.params.id == "add") {
            setTs(TimeSlot.Create(new TimeSlot(), timeSlotGroup || new TimeSlotGroup()))
        }
        else {
            const id = parseId(props.match.params.id)
            if (typeof id == undefined) {
                props.history.push(`/timeslots/${props.match.params.groupid}`)
                return
            }
            const ts = timeSlotGroup?.timeSlots.find(x => x.id == id)
            if (!ts) {
                props.history.push(`/timeslots/${props.match.params.groupid}`)
                return
            }
            setTs(ts)
            reset(ts)
        }

    }, [timeSlotGroup])
    React.useEffect(() => {
        if (!externalProvidersOptions) {
            dispatch(timeSlotsActions.requestExternalProviders())
        }
    }, [])

    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        setValue,
        watch,
        reset,
    } = useForm()
    const onSubmit = (data: any) => {
        if (!timeSlotGroup) {
            alert("Time slot group not initialized")
            return
        }
        // if (data.timeSlots && data.timeSlots.length > 0) {
        //     data.timeSlots = data.timeSlots.map((ts: any) => {
        const _ts = Object.assign(new TimeSlot(), data, {
            daysOffered: DaysOfferedService.encode(data.daysOfferedList),
        }) as TimeSlot
        _ts.startTimeDescription = data.startTimeDescription
        _ts.endTimeDescription = data.endTimeDescription
        _ts.groupId = timeSlotGroup.id
        TimeSlot.SetTimeType(_ts, _ts.timeType)
        // })
        dispatch(timeSlotsActions.saveTimeSlot(timeSlotGroup, _ts))
        // }
    }
    const _ts = watch()
    React.useEffect(() => {
        if (timeSlotGroup) {
            if (_ts.externalProviderId) {
                dispatch(timeSlotsActions.requestExternalOffers(_ts.externalProviderId))
                if (_ts.externalProductId) {
                    dispatch(timeSlotsActions.requestExternalTimeSlots(_ts.externalProviderId, _ts.externalProductId))
                }
            }
        }
    }, [_ts])
    const externalTimeSlotsOptions = externalTimeSlotsMap?.get(_ts.externalProviderId)?.get(_ts.externalProductId || [])
    const externalTimeSlotsOptionsForChild = externalTimeSlotsMap?.get(_ts.externalProviderId)?.get(_ts.externalProductPerChildId || [])
    const selectedProviderId = _ts.externalProviderId
    const selectedProdiverOption = (selectedProviderId ? externalProvidersOptions?.find(x => x.value == selectedProviderId) : undefined) as (ExternalProviderOption | undefined)
    const isTimeSlotsIndependant = watch("isTimeSlotsIndependant")
    const timeSlotTypesOptioons = React.useMemo(() => getTimeSlotTypeOptions(Localization), [Localization])
    const timeSlotTimeTypesOptions = React.useMemo(() => getTimeSlotTimeTypeOptions(Localization), [Localization])
    return <ContainerWithPadding>
        <Grid>
            <SectionTitle
                title={Localization.getString(
                    ts.id
                        ? `${Localization.getString('Edit time slot')}`
                        : Localization.getString('Add new time slot'),
                )}
            />
            <Link className="a-back-to-list" to={`/timeslots/${props.match.params.groupid}`}>
                {Localization.getString('Back to time slots group')}
            </Link>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Row key={`${ts.guid}`} id={`ts-${ts.guid}`}>
                    <Col type="50">
                        <Controller
                            name={nameof<TimeSlot>("id")}
                            defaultValue={ts.id}
                            control={control}
                            render={({ field }) => (
                                <input
                                    {...field}
                                    hidden
                                    value={ts.id}
                                    name="id"
                                    type="number"
                                    onChange={([e]: any) => parseInt(e.target.value, 10)}
                                />
                            )}
                        />
                        <TextFormField
                            label={Localization.getString('Time Slot Name')}
                            isRequired
                            error={
                                errors.name ? Localization.getString('Time slot name is required') : undefined
                            }
                            defaultValue={ts.name}
                            name={nameof<TimeSlot>("name")}
                            register={register}
                            options={{
                                required: Localization.getString('Time slot name is required'),
                            }}
                        />
                        <SelectFormFieldController
                            name={nameof<TimeSlot>("daysOfferedList")}
                            isMultiple
                            options={daysOfferedOptions}
                            label={Localization.getString('Days offered')}
                            error={
                                errors.daysOfferedList && errors.daysOfferedList.message
                            }
                            defaultValue={DaysOfferedService.getDays(ts.daysOffered)}
                            onChange={(e: any) => {
                                const prev = DaysOfferedService.getDays(_ts.daysOffered)
                                let res = e ? (e as number[]) : []
                                if (res.some((x) => x == 0)) {
                                    if (prev.some((x) => x == 0)) {
                                        res = res.filter((x) => x != 0)
                                    } else {
                                        res = [0]
                                    }
                                }
                                if (res.length == 0) {
                                    res.push(0)
                                }
                                const daysOfferedVal = DaysOfferedService.encode(res)
                                setValue(nameof<TimeSlot>("daysOffered"), daysOfferedVal)
                                setValue(nameof<TimeSlot>("daysOfferedList"), res)
                                return res
                            }}
                            control={control}
                        />
                        {isTimeSlotsIndependant
                            ? <NumberFormField
                                name={nameof<TimeSlot>("capacity")}
                                defaultValue={ts.capacity}
                                label={`${Localization.getString(
                                    'Capacity',
                                )}, ${Localization.getString('people')}`}
                                min={0}
                                register={register}
                                onChange={([e]) => parseFloat(e.target.value) || 0}
                            />
                            : null}
                        <SelectFormFieldController
                            name={nameof<TimeSlot>("type")}
                            label={Localization.getString('Availability settings')}
                            options={timeSlotTypesOptioons}
                            control={control}
                        />
                        <FormFieldHidable hidden={ts.type != TimeSlotType.OnRequest}>
                            <NumberFormField
                                name={nameof<TimeSlot>("cutOffResponseTime")}
                                defaultValue={ts.cutOffResponseTime}
                                label={`${Localization.getString(
                                    'Cut off response time',
                                )}, ${Localization.getString('hours')}`}
                                min={0}
                                register={register}
                                onChange={([e]) => parseFloat(e.target.value) || 0}
                            />
                        </FormFieldHidable>
                        <SelectFormFieldController
                            name={nameof<TimeSlot>("pickUpTimeId")}
                            label={Localization.getString('Override pick up time')}
                            options={pickUpTimesOptions}
                            defaultValue={ts.pickUpTimeId}
                            control={control}
                        />
                        <NumberFormField
                            name={nameof<TimeSlot>("capacity")}
                            register={register}                            
                            defaultValue={ts.capacity}
                            label={`${Localization.getString(
                                'Override capacity',
                            )}`}
                            placeholder={`Default: ${timeSlotGroup?.capacity}`}
                            toolTip={`Default: ${timeSlotGroup?.capacity}`}
                            min={1}
                        />
                    </Col>
                    <Col type="50">
                        <SelectFormFieldController
                            name={nameof<TimeSlot>("timeType")}
                            label={Localization.getString('Time settings')}
                            options={timeSlotTimeTypesOptions}
                            error={errors.timeType && errors.timeType.message}
                            control={control}
                        />
                        <FormFieldHidable hidden={false}>
                            <TimePickerFormFieldController
                                name={nameof<TimeSlot>("startTimeDescription")}
                                defaultValue={ts.startTimeDescription}
                                label={`${Localization.getString('Start time')}`}
                                error={
                                    errors.startTimeDescription
                                        ? errors.startTimeDescription.message
                                        : ''
                                }
                                id={nameof<TimeSlot>("startTimeDescription")}
                                control={control}
                            />
                            <TimePickerFormFieldController
                                name={nameof<TimeSlot>("endTimeDescription")}
                                defaultValue={ts.endTimeDescription}
                                label={`${Localization.getString('End time')}`}
                                error={
                                    errors.endTimeDescription ? errors.endTimeDescription.message : ''
                                }
                                id={nameof<TimeSlot>("endTimeDescription")}
                                control={control}
                            />
                        </FormFieldHidable>
                        <NumberFormField
                            name={nameof<TimeSlot>("interval")}
                            register={register}
                            defaultValue={ts.interval}
                            label={`${Localization.getString(
                                'Interval',
                            )}, ${Localization.getString('minutes')}`}
                            error={
                                errors.timeSlots &&
                                    errors.timeSlots.length > 0 &&
                                    !ts.interval
                                    ? Localization.getString('Interval is required')
                                    : undefined
                            }
                            options={{
                                validate: (value: number) =>
                                    ts.timeType == TimeSlotTimeType.Anytime && !value && !ts.isExternalId
                                        ? Localization.getString('Interval is required')
                                        : undefined,
                            }}
                            min={0}
                        />
                        <ToggleFieldController
                            name={nameof<TimeSlot>("isExternalId")}
                            label={Localization.getString('Is External')}
                            id={nameof<TimeSlot>("externalId")}
                            control={control}
                            onChange={(e: boolean) => {
                                if (!e) {
                                    setValue(nameof<TimeSlot>("externalProviderId"), undefined)
                                    setValue(nameof<TimeSlot>("externalProviderCodeType"), ExternalProviderCodeType.None)
                                    setValue(nameof<TimeSlot>("externalId"), "")
                                    setValue(nameof<TimeSlot>("externalPerChildId"), "")
                                    setValue(nameof<TimeSlot>("bookingReferencePrefix"), "")
                                    setValue(nameof<TimeSlot>("externalProductId"), "")
                                    setValue(nameof<TimeSlot>("externalProductPerChildId"), "")

                                }
                                setValue(nameof<TimeSlot>("isExternalId"), e)
                            }}
                        />
                        {_ts.isExternalId
                            ? <>
                                <SelectFormFieldController
                                    name={nameof<TimeSlot>("externalProviderId")}
                                    label={Localization.getString('External provider') + (_ts.externalProviderCodeType) ? ` (Code Type: ${ExternalProviderCodeTypesNames[_ts.externalProviderCodeType]})` : ""}
                                    options={externalProvidersOptions || []}
                                    error={errors.externalProviderId && errors.externalProviderId.message}
                                    control={control}
                                    onChange={(e: SelectOptionModel) => {
                                        const externalProviderId = e.value as number
                                        if (!externalOffersMap?.has(externalProviderId)) {
                                            dispatch(timeSlotsActions.requestExternalOffers(externalProviderId))
                                        }
                                        setValue(nameof<TimeSlot>("externalProviderDiffProductsAdultChild"), (e as ExternalProviderOption).isDifferentProducts)
                                        setValue(nameof<TimeSlot>("externalProviderCodeType"), (e as ExternalProviderOption).codeType)
                                        setValue(nameof<TimeSlot>("bookingReferencePrefix"), (e as ExternalProviderOption).bookingReferencePrefix)
                                        if (externalProviderId != _ts.externalProviderId) {
                                            setValue(nameof<TimeSlot>("externalId"), "")
                                            setValue(nameof<TimeSlot>("externalPerChildId"), "")
                                            setValue(nameof<TimeSlot>("externalProductId"), "")
                                            setValue(nameof<TimeSlot>("externalProductPerChildId"), "")
                                        }
                                    }}
                                />
                            </>
                            : null}
                        {_ts.isExternalId ? <ToggleFieldController
                            name={nameof<TimeSlot>("externalIsTicketPerPax")}
                            label={Localization.getString('Is Ticket Per Pax')}
                            subLabel='If selected, then voucher will be generated for each pax with ticket number in QR code'
                            id={nameof<TimeSlot>("externalIsTicketPerPax")}
                            control={control}
                        /> : null}
                        {_ts.isExternalId ? <SelectFormFieldController
                            name={nameof<TimeSlot>("externalProductId")}
                            label={`${Localization.getString('External product')} (Ext. mapping: ${ts.externalProductMappingValue})`}
                            options={externalOffersMap?.get(_ts.externalProviderId) || []}
                            error={errors.externalProviderId && errors.externalProviderId.message}
                            control={control}
                            onChange={(e: SelectOptionModel) => {
                                const externalProductId = e.value as string
                                const apiProviderId = _ts.externalProviderId
                                if (!externalTimeSlotsMap?.has(apiProviderId) || !externalTimeSlotsMap.get(apiProviderId)?.has(externalProductId)) {
                                    if (_ts.timeType == TimeSlotTimeType.Fixed) {
                                        dispatch(timeSlotsActions.requestExternalTimeSlots(_ts.externalProviderId, externalProductId))
                                    }
                                }
                            }}
                        /> : null}
                        {(_ts.isExternalId)
                            ? <>{ts.externalProductPerChildId && ts.externalProductPerChildId.length > 0 && <i onClick={() => { setValue(nameof<TimeSlot>("externalProductPerChildId"), "") }} className='fa fa-times clickable float-right' />}
                                <SelectFormFieldController
                                    name={nameof<TimeSlot>("externalProductPerChildId")}
                                    label={`${Localization.getString('External product for child')} (Ext. mapping: ${ts.externalProductPerChildMappingValue})`}
                                    options={externalOffersMap?.get(_ts.externalProviderId) || []}
                                    error={errors.externalProviderId && errors.externalProviderId.message}
                                    control={control}
                                    onChange={(e: SelectOptionModel) => {
                                        const externalProductPerChildId = e.value as string
                                        const apiProviderId = _ts.externalProviderId
                                        if (!externalTimeSlotsMap?.has(apiProviderId) || !externalTimeSlotsMap.get(apiProviderId)?.has(externalProductPerChildId)) {
                                            if (_ts.timeType == TimeSlotTimeType.Fixed) {
                                                dispatch(timeSlotsActions.requestExternalTimeSlots(_ts.externalProviderId, externalProductPerChildId))
                                            }
                                        }
                                    }}
                                /></> : null}
                        {(_ts.isExternalId && _ts.externalProductId && _ts.timeType == TimeSlotTimeType.Fixed)
                            ? <>
                                <SelectFormFieldController
                                    name={nameof<TimeSlot>("externalId")}
                                    label={Localization.getString('External time slot')}
                                    options={externalTimeSlotsOptions ?? []}
                                    error={(errors.externalProductId && errors.externalProductId.message) || (externalTimeSlotsOptions?.length == 0 ? "No time slots for selected product. Maybe it should be guest defines time?" : undefined)}
                                    control={control}
                                />
                            </>
                            : null}

                        {(_ts.isExternalId && _ts.externalProductPerChildId && _ts.timeType == TimeSlotTimeType.Fixed)
                            ? <>
                                {ts.externalPerChildId && ts.externalPerChildId.length > 0 && <i onClick={() => { setValue(nameof<TimeSlot>("externalPerChildId"), "") }} className='fa fa-times clickable float-right' />}
                                <SelectFormFieldController
                                    name={nameof<TimeSlot>("externalPerChildId")}
                                    label={Localization.getString('External time slot for child')}
                                    options={externalTimeSlotsOptionsForChild ?? []}
                                    error={(errors.externalProductPerChildId && errors.externalProductPerChildId.message) || (externalTimeSlotsOptionsForChild?.length == 0 ? "No time slots for selected product. Maybe it should be guest defines time?" : undefined)}
                                    control={control}
                                />
                            </>
                            : null}

                        {(_ts.isExternalId)
                            ? <>
                                <TextFormField
                                    label={Localization.getString('Booking prefix')}
                                    subLabel={(selectedProdiverOption && selectedProdiverOption.bookingReferencePrefix != _ts.bookingReferencePrefix) ? `Default  prefix:${selectedProdiverOption?.bookingReferencePrefix}` : undefined}
                                    defaultValue={ts.bookingReferencePrefix}
                                    placeholder={(selectedProdiverOption && selectedProdiverOption.bookingReferencePrefix != _ts.bookingReferencePrefix) ? `Default  prefix:${selectedProdiverOption?.bookingReferencePrefix}` : undefined}
                                    name={nameof<TimeSlot>("bookingReferencePrefix")}
                                    register={register}
                                />
                                {/* <SelectFormFieldController
                                                            name={fNames.bookingReferencePrefix}
                                                            label={Localization.getString('Booking prefix')}
                                                            placeholder={(selectedProdiverOption && selectedProdiverOption.bookingReferencePrefix != getValues(fNames.bookingReferencePrefix)) ? `Default  prefix:${selectedProdiverOption?.bookingReferencePrefix}` : undefined}
                                                            options={externalTimeSlotsOptionsForChild}
                                                            control={control}
                                                        /> */}
                            </>
                            : null}

                        {/* <FormFieldHidable hidden={ts.timeType != TimeSlotTimeType.Anytime || ts.isExternalId}> */}
                        {/* <FormFieldHidable hidden={false}> */}
                        {/* <NumberFormField
                                                        name={fNames.duration}
                                                        register={register}
                                                        defaultValue={ts.duration}
                                                        label={`${Localization.getString(
                                                            'Duration',
                                                        )}, ${Localization.getString('hours')}`}
                                                        error={
                                                            errors.timeSlots &&
                                                                errors.timeSlots.length > 0 &&
                                                                !ts.duration
                                                                ? Localization.getString('Duration is required')
                                                                : undefined
                                                        }
                                                        min={0}
                                                        options={{
                                                            validate: (value: number) =>
                                                                ts.timeType == TimeSlotTimeType.Anytime && !value
                                                                    ? Localization.getString('Duration is required')
                                                                    : undefined,
                                                        }}
                                                    /> */}
                        {/* </FormFieldHidable> */}
                    </Col>
                </Row>
                <Buttons.StickySaveButton>{Localization.getString('Save')}</Buttons.StickySaveButton>
            </form>
        </Grid>
    </ContainerWithPadding>
}
export default TimeSlotForm